import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

const CustomTooltip = withStyles((theme) => ({
    tooltip: {
        border: "1px solid #4D4D4D",
        "background-color": "#FFFFFF",
        "box-shadow": "5px 5px 5px 0 rgba(0,0,0,0.5)",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: "0",
        lineHeight: "17px",
        minWidth: 530
    },
}))(Tooltip);

export default CustomTooltip; 